module.exports = __webpack_public_path__ + "img/skills-wind-dru-2.c2cf9163.png";